import {
  FilterGroupDto,
  PaginatedSMSMessagesDto,
  PaginatedUsersDto,
  SMSMessageDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const smsMessageRequests = {
  getSMSMessages: EndpointDefinition.get<
    PaginatedSMSMessagesDto,
    {
      subjectIds?: string;
      onlyUnassignedMessages?: boolean;
      showOnlyMyTexts?: boolean;
      textType?: 'unassigned' | 'resource';
      directionType?: 'incoming' | 'outgoing';
      searchTerm?: string;
      searchTermType?: 'string' | 'subjectId' | 'number';
      'page-start'?: number;
      'page-size'?: number;
    }
  >({
    name: 'getSMSMessages',
    route: '/sms',
  }),

  getSMSFilters: EndpointDefinition.get<FilterGroupDto, { named?: string }>({
    name: 'getSMSFilters',
    route: '/sms/filters',
  }),

  assignSMSMessage: EndpointDefinition.patch<
    SMSMessageDto,
    {},
    {
      id: number;
    }
  >({
    name: 'assignSMSMessage',
    route: '/sms/:id',
  }),

  updateSmsNoFollowUpNeeded: EndpointDefinition.post<
    SMSMessageDto,
    { noFollowUpNeeded: boolean },
    { id: number }
  >({
    name: 'updateSmsNoFollowUpNeeded',
    route: '/sms/:id/no_follow_up_needed',
  }),

  unassignSMSMessage: EndpointDefinition.delete<
    SMSMessageDto,
    {
      id: number;
    }
  >({
    name: 'unassignSMSMessage',
    route: '/sms/:id',
  }),

  getMembersForSMSAssignment: EndpointDefinition.get<
    PaginatedUsersDto,
    {
      id: number;
      searchTerm?: string;
      phoneNumber?: string;
    }
  >({
    name: 'getMembersForSMSAssignment',
    route: '/sms/:id/members',
  }),
};
